// @flow
import * as React from 'react';
import {useLocation, useHistory} from "react-router-dom";
import styled from 'styled-components';
import ButtonIndex from 'components/ButtonIndex';
import {LocalizedParagraph, Paragraph, useLocalized} from 'components/Localized';
import Logo from 'components/Logo';
import Space from 'components/Space';
import ButtonSpot from 'components/ButtonSpot';
import ButtonNextPage from 'components/ButtonNextPage';
import SpotMessage from 'components/SpotMessage';
import GuideMessageContainer from 'components/GuideMessageContainer';
import GuideMessageCenter from 'components/GuideMessageCenter';
import Icon360Degree from 'components/Icon360Degree';
import ButtonList from './ButtonList';
import MenuUSP from './MenuUSP';
import * as VRUtils from 'utils/vrUtils';
import * as VideoUtils from 'utils/videoUtils';
import Disclaimer from 'components/Disclaimer'
import * as AudioUtils from 'utils/audioUtils';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

type Props = {
  onOpenModalIndex: () => void,
  openModalIndex: boolean,
  onNext: () => void,
};

export default function InCarExperience(props: Props): React.Element<any> {
  const history = useHistory();
  const goto = useQuery().get("goto");
  const gotoNo = React.useMemo(() => goto != null ? parseInt(goto) : null, [goto]);

  const localized = useLocalized();
  const [page, setPage] = React.useState(gotoNo ?? -1);
  const [openList, setOpenList] = React.useState(false);
  const [loadingCompleted, setLoadingCompleted] = React.useState(false);
  const {onNext} = props;
  const [videoB03_1Completed, setVideoB03_1Completed] = React.useState(false);

  const readPixelPage11Canvas_id = "readPixelPage11Canvas";
  const refCameraMoved = React.useRef(null);

  const [page0CameraMoved, setPage0CameraMoved] = React.useState(false);
  const [page8CameraMoved, setPage8CameraMoved] = React.useState(false);
  
  React.useEffect(()=>{
    if (page === 8) {
      AudioUtils.playBGM_music();
    }
    else if (page < 9) {
      AudioUtils.stopBGM();
    } else {
      AudioUtils.playBGM_UI2();
    }
    
    return ()=>{
    };
  }, [page]);


  React.useEffect(()=>{
    window.tagManager.drivingZoneCourseBInCarExperiencePage();
  },[]);
  
  React.useEffect(()=>{
    //window.tagManager.drivingZoneCourseBInCarExperiencePage();
    if (page === -1) {
      window.tagManager.drivingZoneCourseBInCarExperienceStep1();
    }
    if (page === 2 && videoB03_1Completed) {
      window.tagManager.drivingZoneCourseBInCarExperienceStep2();
    }

  },[page, videoB03_1Completed]);

  React.useEffect(()=>{
    if (page === 0) {
        VideoUtils.lookAtDefault();

    }
    const id = readPixelPage11Canvas_id;
    //console.log("readPixelPage11:page=", page);

    const elm0 = document.getElementById(id);
    if (page === 10 || page === 11 || page === 12) {
      if (elm0 != null) {
        return;
      }
      const c = document.createElement("canvas");
      c.id = id;
      c.style.position = "absolute";
      c.style.left = "0px";
      c.style.top = "0px";
      c.style.visibility = "hidden";
      document.body?.appendChild(c);

      const ii = document.createElement("img");
      ii.style.visibility = "hidden";

      document.body?.appendChild(ii);

      const url = (process.env.PUBLIC_URL ?? '') +'/video-meta/B03_7_vr-mask.jpg';
      ii.src = url;

      ii.addEventListener("load", function(){
        c.width = ii.naturalWidth;
        c.height = ii.naturalHeight;
        const ctx = c.getContext("2d");
        ctx.drawImage(ii, 0, 0, c.width, c.height);
        document.body?.removeChild(ii);
      });

    } else {
      const elm = document.getElementById(id);
      if (elm != null) {
        document.body?.removeChild(elm);
      }
    }

    return ()=>{
      const elm = document.getElementById(id);
      if (elm != null) {
        document.body?.removeChild(elm);
      }
    };

  }, [page]);

  const readPixelPage11 = React.useCallback((u, v) => {
    const id = readPixelPage11Canvas_id;
    const canvas = document.getElementById(id);
    if (canvas == null) {
      return false;
    }
    if (!(canvas instanceof HTMLCanvasElement)) {
      return false
    }
    const ctx = canvas.getContext("2d");
    const x = Math.floor(Math.min(canvas.width * u, canvas.width - 1));
    const y = Math.floor(Math.min(canvas.height * v, canvas.height - 1));
    const data = ctx.getImageData(x, y, 1, 1).data;
    
    
    var lum = data[0] / 255 * 0.30 + data[1] / 255 * 0.59 + data[2] / 255 * 0.11;

    //console.log("getImageData:x,y,data,lum=",x,y,data, lum);
    return lum >= 0.5;

  }, []);

  const touch3DCallback = React.useCallback(()=>{
    console.log("touch3DCallback, page:", page);
    if (page === 11) {
      setPage(12);
      VideoUtils.loadB03_8();
      VideoUtils.play();

    }
    
  }, [page]);

  const handleTouch3D = React.useCallback((theta:number, phi:number) => {

    phi += 90.0;
    if (phi < 0) {
      phi += 360;
    }

    if (theta < 0) {
      theta += 360;
    }

    var v = theta / 180.0;
    var u = phi / 360.0;
    if (readPixelPage11(u, v)) {
      touch3DCallback();
    }
    console.log("u, v, test, page:", u, v, readPixelPage11(u, v), page);
  }, [page, readPixelPage11, touch3DCallback]);

  React.useEffect(()=>{
    VRUtils.addVREventListener("pointController:handlers:touchSpherical", handleTouch3D);

    return ()=>{
      VRUtils.removeVREventListener("pointController:handlers:touchSpherical", handleTouch3D);  
    };
  }, [page, handleTouch3D]);
console.log("InCarExperience page=", page);
  const handleNextPage = React.useCallback((next?: number) => {
    const nextProvided = next != null && !isNaN(next);
    const nextPage = nextProvided ? (next ?? (page + 1)) : (page + 1);
    //console.log("InCarExperience page=", page, "nextPage=", nextPage);
    
    if (page === 0) {
      window.tagManager.carExperienceStep1NextLinkClick();
    }
    if (page === 2) {
      //
      //window.tagManager.navigationCurvedDisplayLinkClick();
    }
    if (page === 4) {
      //window.tagManager.navigationPremiumSoundLinkClick();
    }
    if (page === 5) {
      window.tagManager.carExperienceStep2NextLinkClick();
    }

    if (page === 9) {
      //window.tagManager.navigationEcoMaterialLinkClick();
    }

    if (page === 12) {
      window.tagManager.carExperienceStep3StarToJourneyLinkClick();
      onNext();
    } else {

      let gotoNextPage = true;
      if (nextPage === 2) {
        VideoUtils.loadB03_1();

        VideoUtils.onEnd(()=>{
          setVideoB03_1Completed(true);
        });

        VideoUtils.play();
      }
      if (nextPage === 3) {
        VideoUtils.loadB03_2();
      }
      else if (nextPage === 4) {
        VideoUtils.loadB03_3();
      }
      else if (nextPage === 5) {
        //VideoUtils.loadB03_4();
        VideoUtils.loadB03_3();
      }
      else if (nextPage === 6) {
        VideoUtils.play();
      }
      else if (nextPage === 7) {
        VideoUtils.loadB03_5();
        VideoUtils.play();
      }
      else if (nextPage === 8) {
      }
      else if (nextPage === 9) {
        VideoUtils.loadB03_6();
        VideoUtils.play();
      }
      else if (nextPage === 10) {
        VideoUtils.loadB03_7();
        // 
        // 
      }
      else if (nextPage === 11) {
        //VideoUtils.loadB03_7();
        // VideoUtils.loadB03_8();
        // VideoUtils.play();

      }
      else if (nextPage === 12) {
        //VideoUtils.loadB03_7();

        //VideoUtils.loadB03_8();
        //VideoUtils.play();
        gotoNextPage = false;
      }

      if (gotoNextPage) {
        setPage(nextPage);
      }
      
    }
  }, [page, onNext]);

  React.useEffect(()=>{
    function markCameraMoved() {
      refCameraMoved.current = true;
      if (page === -1) {
        setPage0CameraMoved(true);
        handleNextPage();
      }
      // if (page === 0) {
      //   setPage0CameraMoved(true);
      // }
      if (page === 8) {
        setPage8CameraMoved(true);
      }
    }

    VRUtils.addVREventListener("camera:move", markCameraMoved);
    return ()=>{
      VRUtils.removeVREventListener("camera:move", markCameraMoved);
    };
  }, [page, setPage0CameraMoved, setPage8CameraMoved, handleNextPage]);


  React.useEffect(()=>{
    if (loadingCompleted) {
      return;
    }

    let cancelWait = ()=>{};
    VRUtils.waitVREventListener(window.videoPlayer.VR_BIND_EVENT, ()=>{
      
      setLoadingCompleted(true);
      VideoUtils.loadB03_1();

      
    }, (cancelWaitValue)=>{
      cancelWait = cancelWaitValue;
    });
    

    return ()=>{
      console.log("calling cancel wait");
      
      
      cancelWait();
    };

  }, [loadingCompleted]);

  React.useEffect(() => {
    if (gotoNo != null) {
      handleNextPage(gotoNo);
      history.replace(history.location.pathname);
    }
    //eslint-disable-next-line
  }, [gotoNo]);

  const handleSpot6Click = React.useCallback(()=>{
    setPage(8);
    VideoUtils.loadB03_5();
    VideoUtils.play();
    VRUtils.fireVREvent("smoothLookat", new window.pc.Vec3(-0.01855154916720209 , -1.298493150652351 , 2.7043615471553406) );
  }, []);


  const refSpot2 = VideoUtils.CreateAddPoint3DCallback("InCarExperience2", -0.002588792940953325 , -0.6730861646503419 , 2.9235164294232043, loadingCompleted);
  //const refSpot5 = VideoUtils.CreateAddPoint3DCallback("InCarExperience5", -0.04813390389246712 , -1.2553318905404751 , 2.724302657908652, loadingCompleted);
  const refSpot6 = VideoUtils.CreateAddPoint3DCallback("InCarExperience7", 1.8460949507824331 , -1.5159775963075743 , 1.814867863010725, loadingCompleted, true);
  const refSpot6b = VideoUtils.CreateAddPoint3DCallback("InCarExperience7b", -1.8531411365245734 , -1.5098264580957248 , 1.8128132817680171, loadingCompleted, true);
  const refSpot10 = VideoUtils.CreateAddPoint3DCallback("InCarExperience10", -1.146561249870711 , -1.057428783069218 , 2.562663003407133, loadingCompleted);
  const refSpot10b = VideoUtils.CreateAddPoint3DCallback("InCarExperience10b", -2.05961057337721 , -1.5760793959646828 , 1.5079714929826757, loadingCompleted, true);


  return (
    <main>
    <GuideMessageCenter show={page === 8 && page8CameraMoved !== true}>
      <GuideIcon360Degree />
    </GuideMessageCenter>
    <GuideMessageCenter show={page === -1}>
      {page0CameraMoved !== true && <GuideIcon360Degree />}
    </GuideMessageCenter>

      <GuideMessageContainer onClick={handleNextPage}>
        <GuideMessageCenter show={page === 0}>
          <LocalizedParagraph {...localized.driving_b03_guide_001} />
          <Space heightM={13} heightD={21} />
          <LocalizedParagraph {...localized.driving_b03_guide_002} />
          
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 1} localText={localized.driving_b03_guide_031}>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 2 && videoB03_1Completed}>
          <Space heightM={5} heightD={38} />
          <GuideTitle><LocalizedParagraph {...localized.driving_b03_guide_021} /></GuideTitle>
          <Space heightM={20} heightD={20} />
          <LocalizedParagraph {...localized.driving_b03_guide_032} />
          <Space heightM={16} heightD={25} />
          <DivStart><Paragraph textKey="driving_b03_incar_210303_001" /></DivStart>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 4}>
          <GuideTitle><LocalizedParagraph {...localized.driving_b03_guide_022} /></GuideTitle>
          <Space heightM={20} heightD={20} />
          <LocalizedParagraph {...localized.driving_b03_guide_033} />
          <Space heightM={16} heightD={25} />
          <DivStart><Paragraph textKey="driving_b03_incar_210303_001" /></DivStart>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 5}>
          <LocalizedParagraph {...localized.driving_b03_guide_034} />
        </GuideMessageCenter>

        <GuideMessageCenter show={page === 9}>
          <Space heightM={5} heightD={38} />
          <GuideTitle><LocalizedParagraph {...localized.driving_b03_guide_023} /></GuideTitle>
          <Space heightM={20} heightD={20} />
          <LocalizedParagraph {...localized.driving_b03_guide_035} />
          <Space heightM={16} heightD={25} />
          <DivStart><Paragraph textKey="driving_b03_incar_210303_001" /></DivStart>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 11}>
          <LocalizedParagraph {...localized.driving_b03_guide_036} />
        </GuideMessageCenter>
      </GuideMessageContainer>
      {page === 3 && videoB03_1Completed && 
        <GuideDiv>
          <ButtonSpot ref={refSpot2}
            onClick={() => {
              
              setPage(4); 
              VideoUtils.loadB03_2();
            } }
            >
            <SpotMessage localText={localized.driving_b03_guide_041} />
          </ButtonSpot>
        </GuideDiv>}
      {page === 6 && 
        <GuideDiv>
          <ButtonSpot  id="spot6" ref={refSpot6}
            onClick={() => {
              handleSpot6Click();
            }}
            >
          </ButtonSpot>
        </GuideDiv>}
        {page === 6 && 
          <GuideDiv>
            <ButtonSpot id="spot6b" ref={refSpot6b}
              onClick={() => {
                handleSpot6Click();
              }}
              >
            </ButtonSpot>
          </GuideDiv>}
      {page === 10 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot10}
            onClick={() => {
              setPage(11);
              VideoUtils.loadB03_7();
              VideoUtils.play();

            }}
            >
          </ButtonSpot>
        </GuideDiv>}
      {page === 10 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot10b}
            onClick={() => {
              setPage(11);
              VideoUtils.loadB03_7();
              VideoUtils.play();

            }}
            >
          </ButtonSpot>
        </GuideDiv>}

      {page === 5 && <ButtonNextPage onNext={handleNextPage} title={localized.button_next} />}
      {page === 8 && <ButtonNextPage title={localized.driving_b03_guide_051} onNext={handleNextPage} />}
      {page === 12 && <ButtonNextPage title={localized.driving_b03_guide_052} onNext={handleNextPage} widthM={151} widthD={240} />}
      {((page === 2 && videoB03_1Completed) || page > 2 ) && <ButtonList onOpenList={() => setOpenList(!openList)} openList={openList} />}
      {page >= 2 && openList && <MenuUSP section="in-car-experience" page={page} onClose={() => setOpenList(false)} onClick={[(menu) => handleNextPage(menu), (menu) => handleNextPage(menu), (menu) => handleNextPage(menu)]} />}
      <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />
      {page < 2 && page >= 0 && <ButtonNextPage onNext={handleNextPage} title={localized.button_next} />}
      <Logo />
      <Disclaimer textKey="disclaimer_default" />
    </main>
  );
}

const GuideDiv = styled.div`
  width: 100%;
  height: 100%;
  button {
    pointer-events: auto;
  }
  position: absolute;
`;

const GuideTitle = styled.div`
  padding: 0px 10px 8px;
  border-bottom: 1px solid #ffffff;
`;

const GuideIcon360Degree = styled(Icon360Degree)`
  position: absolute;
  bottom: ${(props) => (props.theme.layout.mobile ? "calc(50%-53px)" : "calc(50%-166px)")};
`;

const DivStart = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 110 : 180)}px;
  height: ${(props) => (props.theme.layout.mobile ? 40 : 64)}px;
  background-color: #ffffff;

  display:flex;
  align-items: center;
  justify-content: center;

  pointer-events: auto;
`;